import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


// Legacy logs are append-only strings. Content + duplicate occurrence stays stable
// when other entries are inserted, removed or reordered (unlike an array index).
export function keyedLines(lines = [], prefix = "line") {
  const occurrences = new Map();
  return lines.map((text) => {
    const occurrence = (occurrences.get(text) || 0) + 1;
    occurrences.set(text, occurrence);
    return { id: `${prefix}:${text}:${occurrence}`, text };
  });
}
